import React from 'react';
export const FeaturesSection = () => {
  const features = [{
    emoji: '📖',
    title: 'Grimorio completo de 120+ páginas',
    desc: 'Estructurado por módulos: fundamentos, rituales, hierbas, tarot, lunas y hechizos del día a día. Sin relleno.'
  }, {
    emoji: '🌿',
    title: 'Herbario 100% local',
    desc: '20 hierbas que conseguís en cualquier verdulería argentina: ruda, romero, cedrón, laurel, albahaca y más. Con usos mágicos y prácticos.'
  }, {
    emoji: '🌙',
    title: 'Calendario lunar del hemisferio sur',
    desc: 'Fases de la luna para todo el año con rituales sugeridos para cada fase. Por fin algo que coincide con tu cielo.'
  }, {
    emoji: '🔮',
    title: 'Tarot como autoexploración',
    desc: 'Los 22 arcanos mayores explicados para journaling e introspección. Sin predicciones, sin miedo. Solo autoconocimiento.'
  }, {
    emoji: '✨',
    title: '15 rituales listos para usar',
    desc: 'Desde protección hasta amor propio. Con ingredientes de tu casa y paso a paso claro. Tu primer ritual en menos de 10 minutos.'
  }, {
    emoji: '🖨️',
    title: 'Plantillas imprimibles + digital',
    desc: 'Registro de hechizos, diario lunar, seguimiento de tarot, intenciones mensuales. Usalo en pantalla o imprimilo.'
  }];
  return <section className="py-12 px-4 relative z-10 bg-mystic-surfaceDark/50 border-y border-gold-dark/20" data-id="element-61">
      <div className="max-w-5xl mx-auto" data-id="element-62">
        <div className="text-center mb-10" data-id="element-63">
          <p className="text-gold-light font-outfit tracking-widest uppercase mb-2" data-id="element-64">
            Por eso creamos
          </p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-gold-primary mb-4" data-id="element-65">
            Grimorio del Sur 🌙
          </h2>
          <p className="text-xl text-text-primary max-w-2xl mx-auto leading-relaxed" data-id="element-66">
            La guía paso a paso para construir tu práctica espiritual desde
            cero, con rituales diseñados para el hemisferio sur y herramientas
            que ya tenés en tu cocina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-67">
          {features.map((feature, index) => <div key={index} className="surface-gradient border border-gold-dark/20 rounded-xl p-5 hover:border-gold-light/40 transition-all duration-300 hover:-translate-y-1" data-id="element-68">
              <div className="text-3xl mb-3" data-id="element-69">{feature.emoji}</div>
              <h3 className="font-outfit text-lg text-gold-light font-medium mb-2" data-id="element-70">
                {feature.title}
              </h3>
              <p className="text-text-soft leading-relaxed" data-id="element-71">{feature.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
};